/* JHSN cart drawer fix: when the drawer was rendered empty (no <cart-items> on the page), the stock theme never re-rendered it after an add-to-cart. Re-render the drawer body from the bundled section HTML instead. */
(function () {
  var tries = 0;
  function start() {
    if (!(window.theme && theme.pubsub && theme.pubsub.subscribe && theme.pubsub.PUB_SUB_EVENTS)) {
      if (tries++ < 60) setTimeout(start, 200);
      return;
    }
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (event) {
      try {
        var drawer = document.getElementById('CartDrawer');
        var cart = event && event.cart;
        if (!drawer || !cart || cart.errors) return;
        if (drawer.querySelector('cart-items')) return; /* stock handler already does it */
        var id = drawer.getAttribute('data-section-id');
        var html = cart.sections && cart.sections[id];
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var src = doc.getElementById('MiniCart-' + id);
          var dst = document.getElementById('MiniCart-' + id);
          if (src && dst) {
            dst.innerHTML = src.innerHTML;
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
            return;
          }
        }
        if (cart.item_count > 0) document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
      }
      catch (e) { console.error(e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
